import { UTSLocale } from "@smile2impress/attraction-constants";
import { TagFragmentFragment } from "api/cms-website/generated/graphql";

import { UrlsConfig } from "configs/urlsConfig";

import { BlogPostContent } from "../BlogPostLayout.type";

export default (
    tags: TagFragmentFragment[] | null,
    content: BlogPostContent,
    locale: UTSLocale
): { href?: string; text?: string } => {
    const defaultResponse = { href: "", text: "" };
    if (!tags) {
        return defaultResponse;
    }

    const { ctaAlt1, ctaAlt2, ctaAlt3, ctaAlt4 } = content;

    enum TAGS_WITH_STICKY_BUTTON {
        ORTHO = "orthodontic-appointment",
        B2B = "b2b",
        APPOINTMENT = "treatment-appointment",
        NOAPPOINTMENT = "treatment-no-appointment",
    }

    const tagToButtonContent = {
        [TAGS_WITH_STICKY_BUTTON.ORTHO]: {
            text: ctaAlt1,
        },
        [TAGS_WITH_STICKY_BUTTON.APPOINTMENT]: {
            text: ctaAlt2,
        },
        [TAGS_WITH_STICKY_BUTTON.NOAPPOINTMENT]: {
            href: UrlsConfig.ALIGNERS,
            text: ctaAlt3,
        },
        [TAGS_WITH_STICKY_BUTTON.B2B]: {
            href: ((locale: UTSLocale) => {
                switch (locale) {
                    case UTSLocale.GB_EN:
                        return "https://docs.google.com/forms/d/1Ck0Dm_5RE_QiWUIpAhCEM7Q6bkJ3xQOkDMGxMjCKxFk/viewform?edit_requested=true";
                    case UTSLocale.SPAIN_ES:
                        return "https://docs.google.com/forms/d/e/1FAIpQLSc0t-fDdUCmqSUEjs1zb5G7WTJDRDNMECS2OoIrSPlsm-s13g/viewform?vc=0&c=0&w=1&flr=0";
                    case UTSLocale.FRANCE_FR:
                        return "https://docs.google.com/forms/d/13DpVkUbrNcBdQlid3mMCfbIFQuwzx9iKpMKTIVYl8Ws/viewform?edit_requested=true";
                    case UTSLocale.ITALY_IT:
                        return "https://docs.google.com/forms/d/1iGjQBdwTkFEvvMgdg8JkFs43DVMwKP4zgOgcV3dJpXA/viewform?edit_requested=true";
                    default:
                        return "";
                }
            })(locale),
            text: ctaAlt4,
        },
    };
    const tag = tags.find((tag: TagFragmentFragment) =>
        Object.values(TAGS_WITH_STICKY_BUTTON).includes(
            tag.slug as TAGS_WITH_STICKY_BUTTON
        )
    );

    if (tag) {
        return tagToButtonContent[tag.slug as keyof typeof tagToButtonContent];
    }

    return defaultResponse;
};
